/*
Copyright 2020 Bruno Windels <bruno@windels.cloud>
Copyright 2020 The Matrix.org Foundation C.I.C.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

import {BaseMediaTile} from "./BaseMediaTile.js";

export class VideoTile extends BaseMediaTile {
    async loadVideo() {
        const file = this._getContent().file;
        if (file && !this._decryptedFile) {
            this._decryptedFile = await this._loadEncryptedFile(file);
            this.emitChange("videoUrl");
        }
    }

    get videoUrl() {
        if (this._decryptedFile) {
            return this._decryptedFile.url;
        }
        const mxcUrl = this._getContent()?.url;
        if (typeof mxcUrl === "string") {
            return this._mediaRepository.mxcUrl(mxcUrl);
        }
        return "";
    }

    get shape() {
        return "video";
    }

    _isMainResourceImage() {
        return false;
    }
}
